window.addEventListener("load", (event) => {

    var contact_type = 0;
    $("#btnTabConsumer").on('click', function() {
        contact_type = 0;
        $(this).addClass('active');
        $("#btnTabProfessional").removeClass('active');
        $(".business").attr("required", false);
        $(".business").attr("disabled", true);
        $(".business").hide();
    });

    $("#btnTabProfessional").on('click', function() {
        contact_type = 1;
        $(this).addClass('active');
        $("#btnTabConsumer").removeClass('active');
        $(".business").attr("required", true);
        $(".business").attr("disabled", false);
        $(".business").show();
    });
    
    function loadRecaptchaContacts() {

        grecaptcha.execute(recaptchaKeyV3, { action: 'submit' }).then(function (token) {
            var recaptchaResponse = document.getElementById('contacts_recaptcha');
            recaptchaResponse.value = token;

            $.ajax({
                type: "POST",
                data: new FormData(document.getElementById("contact-form")),
                dataType: "json",
                url: ajaxUrl_contact + '?type=' + contact_type ,
                processData: false,
                contentType: false,
                success: function(data) {
                    $('#contact-response').html(data.html);
                    $('#modalContactResponse').modal('show');
                    if (data.result) {
                        dataLayer.push({
                            event: 'submit',
                            context_submitted: 'contact'
                        });
                        fbq_track('Contact');
                    }
                },
                error: function(data) {
                    $('#contact-response').html(data.responseJSON.html);
                    $('#modalContactResponse').modal('show');
                }
            });

            

        });
    }

    $('form#contact-form').on('submit', function(e) {
        e.preventDefault();
        loadRecaptchaContacts();
    });
    
    $('.popup-modal-dismiss').on('click', function() {
        location.reload();
    });
 
})
